module.exports = __webpack_public_path__ + "static/media/lv-ru.041f39d2.mp4";